import {size} from 'lodash'
import {Basic, Ventrata} from 'types'
import {convertUnitItemsToUnitCounterMap} from 'utils/convertUnitItemsToUnitCounterMap'
import {ga4} from 'utils/ga4'
import {getBookingByUuid} from 'utils/getBookingById'
import {getCurrency} from 'utils/getCurrency'
import {getGa4BookingItems} from 'utils/getGa4BookingItems'
import {getHumanPrice} from 'utils/getHumanPrice'

type Params = {
  order: Ventrata.Order
  updatedOrder: Ventrata.Order
  bookingUuid: string
  crossSellingFlag: boolean
}

const getUnitCounterDiff = (a: Basic.UnitCounterMap, b: Basic.UnitCounterMap) => {
  const added: Basic.UnitCounterMap = {}
  const removed: Basic.UnitCounterMap = {}

  for (const unitId of [...Object.keys(a), ...Object.keys(b)]) {
    const aQuantity = a[unitId] || 0
    const bQuantity = b[unitId] || 0

    if (bQuantity > aQuantity) {
      added[unitId] = bQuantity - aQuantity
    } else if (bQuantity < aQuantity) {
      removed[unitId] = aQuantity - bQuantity
    }
  }

  return {
    added,
    removed,
  }
}

export const changeCartItem = ({order, updatedOrder, bookingUuid, crossSellingFlag}: Params) => {
  const booking = getBookingByUuid(order, bookingUuid)
  const updatedBooking = getBookingByUuid(updatedOrder, bookingUuid)
  const currency = getCurrency(order)

  const {added, removed} = getUnitCounterDiff(
    convertUnitItemsToUnitCounterMap(booking.unitItems),
    convertUnitItemsToUnitCounterMap(updatedBooking.unitItems)
  )

  if (size(added) > 0) {
    ga4({
      event: 'add_to_cart',
      ecommerce: {
        currency,
        value: getHumanPrice(updatedBooking.pricing?.retail),
        checkout_type: 'custom_checkout',
        items: getGa4BookingItems(updatedBooking, currency, crossSellingFlag, added),
      },
    })
  }

  if (size(removed) > 0) {
    ga4({
      event: 'remove_from_cart',
      ecommerce: {
        currency,
        value: getHumanPrice(updatedBooking.pricing?.retail),
        checkout_type: 'custom_checkout',
        items: getGa4BookingItems(updatedBooking, currency, crossSellingFlag, removed),
      },
    })
  }
}
